<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Login</h4>
                  <p>Welcome back, please login to your account.</p>
                </div>
                <vs-alert v-if="alert.status" :color="alert.type === 0 ? 'danger' : 'success'" icon-pack="feather" :icon="alert.type === 0 ? 'icon-x-circle' : 'icon-check-circle'">
                  <span>{{ alert.text }}</span>
                </vs-alert>
                <!-- HERE -->
                <div class="mb-4" style="padding: 10px">
                    <vs-input
                        v-validate="'required|min:3'"
                        data-vv-validate-on="blur"
                        name="username"
                        icon-no-border
                        icon="icon icon-user"
                        icon-pack="feather"
                        label-placeholder="Username"
                        v-model="username"
                        class="w-full"
                        v-on:keyup.enter="doLogin" />
                    <span class="text-danger text-sm">{{ errors.first('username') }}</span>

                    <vs-input
                        data-vv-validate-on="blur"
                        v-validate="'required'"
                        type="password"
                        name="password"
                        icon-no-border
                        icon="icon icon-lock"
                        icon-pack="feather"
                        label-placeholder="Password"
                        v-model="password"
                        class="w-full mt-6"
                        v-on:keyup.enter="doLogin" />
                    <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                    <div class="flex flex-wrap justify-between my-5">
                        <!-- <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox> -->
                        <router-link to="/forgot-password">Forgot Password?</router-link>
                    </div>
                    <div class="flex flex-wrap justify-between mb-3">
                      <vs-button  type="border" @click="registerUser">Register</vs-button>
                      <vs-button id="loginBtn" class="vs-con-loading__container" :disabled="!validateForm" @click="doLogin">Login</vs-button>
                    </div>
                  </div>
                <!-- HERE -->

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>


<script>

import API from "@/API.js"
const axios = require('axios')

export default {
  data () {
    return {
      username: '',
      password: '',
      error: 'Server Error',

      verification_code: '',

      alert: {
        status: false,
        type: 0,
        text: ''
      }
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.username !== '' && this.password !== ''
    }
  },
  methods: {
    doLogin () {
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: "#loginBtn",
        scale: 0.45
      })
      // If user is already logged in notify
      axios.post(API.endpoint + '/login', {
        username: this.username,
        password: this.password
      }).then(res => {
        if (res.data.status === true) {
          this.$vs.loading.close("#loginBtn > .con-vs-loading")
          this.$store.dispatch('updateUserInfo', res.data.message.data)
          this.$router.push('/tracking')
        }
      }).catch(error => {
        this.$vs.loading.close("#loginBtn > .con-vs-loading")
        if(typeof error.response.data.message !== undefined) {
          this.error = error.response.data.message.split('_').join(' ')
        }

        this.$vs.notify({
          title: 'Sorry',
          text: this.error,
          color: 'danger',
          position: 'top-right'
        })
      })
    },

    registerUser () {
      this.$router.push('/register')
    }
  },
  created() {    
    this.verification_code = this.$route.params.code

    if(this.verification_code !== '' && this.verification_code !== undefined){
      axios.post(API.endpoint + '/account_verification', {
        code: this.verification_code
      }).then(res => {
        this.alert.status = true
        if(res.data.status) {
          this.alert.type = 1
          this.alert.text = res.data.message
        }
      }).catch(error => {        
        this.alert.status = true
        this.alert.type = 0 
        this.alert.text = error.response.data.message
      })
    }
  }
}
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
